import "./App.css"
import "./ContactForm.css"
import "comp/Fonts/SymbolsOutline/SymbolsOutline.css"
import AppBase from "comp/app/App"
import appConfig from "./Config"
import appVersion from "./Version"
import Router from "./Router"

export default class App extends AppBase {

    constructor(p) {

        super({
            config: appConfig,
            version: appVersion,
            router: Router,
            parent: p.parent
        })

        this.setFavIcon(new URL(
            "../public/EdLogixIcon.png",
            import.meta.url
        ))
    }
}